import { CommonModule, NgIf } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnChanges, signal } from '@angular/core';

import { TooltipDirectiveModule } from '@shared/directives/tooltip.directive';

import { TextOverflowCheckDirective } from '../../directives/text-overflow-check.directive';
import { ISimpleChanges } from '../../types/simple-changes-typed.type';

@Component({
  selector: 'app-fade-text',
  templateUrl: './fade-text.component.html',
  styleUrls: ['./fade-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [CommonModule, TextOverflowCheckDirective, NgIf, TooltipDirectiveModule],
})
export class FadeTextComponent implements OnChanges {
  @Input() text!: string;
  @Input() declare optionalText?: string;
  @Input() optionalTextPositionLeft = true;
  @Input() declare tooltipPrefix?: string;
  @Input() tooltip?: string;
  @Input() maxLines = 1;
  @Input() isEnabled = true;
  @Input() isInline = false;
  @Input() declare customStyles: { [key: string]: any };
  @Input() customOptionalStyles?: { [key: string]: any };
  @Input() disableTooltip = false;

  isOverflowed = signal(false);
  isTooltipMode = signal(false);

  ngOnChanges(changes: ISimpleChanges<FadeTextComponent>): void {
    if (this.tooltipPrefix !== null && this.tooltipPrefix !== undefined) {
      this.isTooltipMode.set(true);
      return;
    }

    if ('isEnabled' in changes) {
      const isEnabled = changes.isEnabled.currentValue;
      if (!isEnabled) {
        this.isTooltipMode.set(false);
      }
    }

    if ('tooltip' in changes) {
      const tooltipValue = changes.tooltip.currentValue;
      if (tooltipValue) {
        this.isTooltipMode.set(true);
      }
    }
  }

  onTextOverflowed(isOverflowed: boolean): void {
    this.isOverflowed.set(isOverflowed);
    if (this.tooltipPrefix !== null && this.tooltipPrefix !== undefined) {
      this.isTooltipMode.set(true);
      return;
    }
    if (this.tooltip) {
      this.isTooltipMode.set(true);
      return;
    }
    if (!this.isEnabled) {
      this.isTooltipMode.set(false);
      return;
    }
    if (!isOverflowed) {
      this.isTooltipMode.set(false);
      return;
    }
    if (!this.disableTooltip) {
      this.isTooltipMode.set(true);
    }
  }
}
